import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser'

@Pipe({
  name: 'safeHtml'
})
export class SafeHtmlPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(value: any, type: string): any {
    if (!type || type === 'html') {
      return this.sanitizer.bypassSecurityTrustHtml(value);
    } else if(type === 'url') {
      return this.sanitizer.bypassSecurityTrustResourceUrl(value);
    } else {
      return value;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/safe-html.pipe.ts